/**
 * GENERATED FILE — do not edit. Source: `apps/web/design-system/tokens/tokens.css` (WEB-999).
 * Regenerate with `pnpm --filter web tokens:generate`; the drift guard in
 * `apps/web/scripts/__tests__/design-tokens.drift.test.ts` fails when this
 * file and the token source disagree.
 */
export const spacingScale = {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    10: '40px',
    12: '48px',
    16: '64px',
    20: '80px',
    24: '96px',
    32: '128px',
    40: '160px',
    48: '192px',
    64: '256px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
};
export const borderRadiusScale = {
    none: '0px',
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
    pill: '9999px',
    full: '9999px',
    cardLg: '14px',
    cardXl: '20px',
    card2xl: '28px',
};
export const shadowScale = {
    xs: '0 1px 2px rgba(15, 20, 31, 0.06)',
    sm: '0 2px 6px rgba(15, 20, 31, 0.08)',
    md: '0 6px 16px rgba(15, 20, 31, 0.1)',
    lg: '0 14px 32px rgba(15, 20, 31, 0.14)',
    xl: '0 22px 48px rgba(15, 20, 31, 0.18)',
    '2xl': '0 22px 48px rgba(15, 20, 31, 0.18)',
};
export const darkShadowScale = {
    xs: '0 1px 2px rgba(0, 0, 0, 0.35)',
    sm: '0 2px 6px rgba(0, 0, 0, 0.4)',
    md: '0 6px 16px rgba(0, 0, 0, 0.45)',
    lg: '0 14px 32px rgba(0, 0, 0, 0.5)',
    xl: '0 22px 48px rgba(0, 0, 0, 0.55)',
    '2xl': '0 22px 48px rgba(0, 0, 0, 0.55)',
};
export const breakpoints = {
    mobile: '375px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
};
export const typographyScale = {
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    fontFamilyAlt: '"SF Pro Display", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontFamilyMono: "'JetBrains Mono', ui-monospace, 'SFMono-Regular', 'Menlo', 'Consolas', 'Liberation Mono', monospace",
    fontFamilyDisplay: "'Space Grotesk', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    fontSize: {
        xs: '12px',
        sm: '13px',
        md: '15px',
        base: '15px',
        lg: '18px',
        xl: '18px',
        '2xl': '22px',
        '3xl': '28px',
        '4xl': '48px',
        micro: '11px',
        caption: '12px',
        small: '13px',
        body: '15px',
        lead: '17px',
        h6: '18px',
        h5: '22px',
        h4: '28px',
        h3: '36px',
        h2: '48px',
        h1: '64px',
        display: '88px',
        mega: '128px',
    },
    lineHeights: {
        tight: 1.04,
        snug: 1.18,
        normal: 1.45,
        loose: 1.65,
    },
    fontWeight: {
        regular: 400,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
};
export const brandColors = {
    brand: {
        primary: '#FFB800',
        light: '#FFCC40',
        dark: '#CC9300',
    },
    accent: {
        primary: '#1E2B4B',
        light: '#3A5891',
        dark: '#0F1833',
    },
    tertiary: {
        primary: '#5B7CB8',
        light: '#7A9AC9',
        dark: '#3A5891',
    },
    city: {
        clt: {
            skyline: '#0E7B7B',
            skylineLight: '#2FA3A3',
            skylineDeep: '#075959',
            skylineGlow: '#4FC4C4',
            skylineWash: 'rgba(14, 123, 123, 0.12)',
            ember: '#E8833A',
            emberLight: '#F2A267',
        },
    },
    gradient: {
        cta: 'linear-gradient(90deg, #FFB800 0%, #0E7B7B 100%)',
        skyline: 'linear-gradient(135deg, #0E7B7B 0%, #2FA3A3 45%, #1E2B4B 100%)',
        dusk: 'linear-gradient(180deg, #0F141F 0%, #1E2B4B 55%, #0E7B7B 115%)',
        sunset: 'linear-gradient(135deg, #FFB800 0%, #FFCC40 45%, #1E2B4B 100%)',
    },
};
export const glassBgStrong = 'rgba(255, 255, 255, 0.1)';
export const glassBorderStrong = 'rgba(255, 255, 255, 0.18)';
export const shadowRingAmber = '0 0 0 4px rgba(255, 184, 0, 0.28)';
export const categoryColorsLight = {
    music: {
        primary: '#4F46E5',
        primaryFg: '#FFFFFF',
        light: '#E0E7FF',
        dark: '#312E81',
    },
    sports: {
        primary: '#047857',
        primaryFg: '#FFFFFF',
        light: '#D1FAE5',
        dark: '#064E3B',
    },
    food: {
        primary: '#C2410C',
        primaryFg: '#FFFFFF',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    tech: {
        primary: '#3B82F6',
        primaryFg: '#FFFFFF',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    art: {
        primary: '#7C3AED',
        primaryFg: '#FFFFFF',
        light: '#EDE9FE',
        dark: '#4C1D95',
    },
    drinks: {
        primary: '#E11D48',
        primaryFg: '#FFFFFF',
        light: '#FFE4E6',
        dark: '#881337',
    },
};
export const categoryColorsDark = {
    music: {
        primary: '#818CF8',
        primaryFg: '#1E1B4B',
        light: '#E0E7FF',
        dark: '#312E81',
    },
    sports: {
        primary: '#34D399',
        primaryFg: '#064E3B',
        light: '#D1FAE5',
        dark: '#064E3B',
    },
    food: {
        primary: '#FB923C',
        primaryFg: '#431407',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    tech: {
        primary: '#60A5FA',
        primaryFg: '#172554',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    art: {
        primary: '#A78BFA',
        primaryFg: '#2E1065',
        light: '#EDE9FE',
        dark: '#4C1D95',
    },
    drinks: {
        primary: '#FB7185',
        primaryFg: '#4C0519',
        light: '#FFE4E6',
        dark: '#881337',
    },
};
export const neighborhoodColorsLight = {
    uptown: {
        primary: '#0D9488',
        light: '#CCFBF1',
        dark: '#134E4A',
    },
    southend: {
        primary: '#B45309',
        light: '#FEF3C7',
        dark: '#78350F',
    },
    noda: {
        primary: '#4338CA',
        light: '#E0E7FF',
        dark: '#312E81',
    },
    plazamidwood: {
        primary: '#BE123C',
        light: '#FFE4E6',
        dark: '#881337',
    },
    dilworth: {
        primary: '#6D28D9',
        light: '#EDE9FE',
        dark: '#4C1D95',
    },
    elizabeth: {
        primary: '#047857',
        light: '#D1FAE5',
        dark: '#064E3B',
    },
    southpark: {
        primary: '#A21CAF',
        light: '#FAE8FF',
        dark: '#701A75',
    },
    loso: {
        primary: '#0284C7',
        light: '#E0F2FE',
        dark: '#0C4A6E',
    },
    freemorewest: {
        primary: '#EA580C',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    mora: {
        primary: '#65A30D',
        light: '#ECFCCB',
        dark: '#365314',
    },
    campnorthend: {
        primary: '#0891B2',
        light: '#CFFAFE',
        dark: '#164E63',
    },
    myerspark: {
        primary: '#9A3412',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    ballantyne: {
        primary: '#2563EB',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    universitycity: {
        primary: '#DC2626',
        light: '#FEE2E2',
        dark: '#7F1D1D',
    },
    historicwestend: {
        primary: '#CA8A04',
        light: '#FEF9C3',
        dark: '#713F12',
    },
    optimistpark: {
        primary: '#16A34A',
        light: '#DCFCE7',
        dark: '#14532D',
    },
    cotswold: {
        primary: '#9333EA',
        light: '#F3E8FF',
        dark: '#581C87',
    },
    wesleyheights: {
        primary: '#DB2777',
        light: '#FCE7F3',
        dark: '#831843',
    },
    wilmore: {
        primary: '#64748B',
        light: '#F1F5F9',
        dark: '#1E293B',
    },
    cherry: {
        primary: '#E11D48',
        light: '#FFE4E6',
        dark: '#881337',
    },
    sedgefield: {
        primary: '#4D7C0F',
        light: '#F7FEE7',
        dark: '#3F6212',
    },
    belmont: {
        primary: '#1D4ED8',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    steelecreek: {
        primary: '#0F766E',
        light: '#CCFBF1',
        dark: '#134E4A',
    },
};
export const neighborhoodColorsDark = {
    uptown: {
        primary: '#2DD4BF',
        light: '#CCFBF1',
        dark: '#134E4A',
    },
    southend: {
        primary: '#FBBF24',
        light: '#FEF3C7',
        dark: '#78350F',
    },
    noda: {
        primary: '#818CF8',
        light: '#E0E7FF',
        dark: '#312E81',
    },
    plazamidwood: {
        primary: '#FB7185',
        light: '#FFE4E6',
        dark: '#881337',
    },
    dilworth: {
        primary: '#A78BFA',
        light: '#EDE9FE',
        dark: '#4C1D95',
    },
    elizabeth: {
        primary: '#34D399',
        light: '#D1FAE5',
        dark: '#064E3B',
    },
    southpark: {
        primary: '#E879F9',
        light: '#FAE8FF',
        dark: '#701A75',
    },
    loso: {
        primary: '#38BDF8',
        light: '#E0F2FE',
        dark: '#0C4A6E',
    },
    freemorewest: {
        primary: '#FB923C',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    mora: {
        primary: '#A3E635',
        light: '#ECFCCB',
        dark: '#365314',
    },
    campnorthend: {
        primary: '#22D3EE',
        light: '#CFFAFE',
        dark: '#164E63',
    },
    myerspark: {
        primary: '#F97316',
        light: '#FFEDD5',
        dark: '#7C2D12',
    },
    ballantyne: {
        primary: '#60A5FA',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    universitycity: {
        primary: '#F87171',
        light: '#FEE2E2',
        dark: '#7F1D1D',
    },
    historicwestend: {
        primary: '#FACC15',
        light: '#FEF9C3',
        dark: '#713F12',
    },
    optimistpark: {
        primary: '#4ADE80',
        light: '#DCFCE7',
        dark: '#14532D',
    },
    cotswold: {
        primary: '#C084FC',
        light: '#F3E8FF',
        dark: '#581C87',
    },
    wesleyheights: {
        primary: '#F472B6',
        light: '#FCE7F3',
        dark: '#831843',
    },
    wilmore: {
        primary: '#94A3B8',
        light: '#F1F5F9',
        dark: '#1E293B',
    },
    cherry: {
        primary: '#F43F5E',
        light: '#FFE4E6',
        dark: '#881337',
    },
    sedgefield: {
        primary: '#84CC16',
        light: '#F7FEE7',
        dark: '#3F6212',
    },
    belmont: {
        primary: '#3B82F6',
        light: '#DBEAFE',
        dark: '#1E3A8A',
    },
    steelecreek: {
        primary: '#14B8A6',
        light: '#CCFBF1',
        dark: '#134E4A',
    },
};
export const neutralScale = {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#0F172A',
};
export const semanticLight = {
    primary: '#0E7B7B',
    primaryForeground: '#FFFFFF',
    secondary: '#1E2B4B',
    secondaryForeground: '#FFFFFF',
    success: '#15803D',
    warning: '#CC9300',
    error: '#B91C1C',
    info: '#0E7B7B',
    background: '#FFFFFF',
    surface: '#F5F7FA',
    surfaceAlt: '#EEF1F6',
    text: '#1E2B4B',
    textMuted: '#6B7280',
    textSecondary: '#4B5563',
    border: '#E4E8F0',
    ring: '#0E7B7B',
    accent: '#0E7B7B',
    accentForeground: '#FFFFFF',
    bgElev: '#F7F8FA',
    surfaceCard: '#FFFFFF',
    surfaceCardAlt: '#F7F8FA',
    borderStrong: '#CBD2DE',
    textInverse: '#FFFFFF',
    textStrong: '#4B5563',
    textQuiet: '#646B78',
    ringFocus: '#0E7B7B',
};
export const semanticDark = {
    primary: '#2FA3A3',
    primaryForeground: '#0F141F',
    secondary: '#4A6DA8',
    secondaryForeground: '#FFFFFF',
    success: '#34D399',
    warning: '#FFCC40',
    error: '#F87171',
    info: '#4FC4C4',
    background: '#0F141F',
    surface: '#1A1F2D',
    surfaceAlt: '#1A1F2D',
    text: '#FFFFFF',
    textMuted: '#9EA6B5',
    textSecondary: '#9EA6B5',
    border: '#2A3142',
    ring: '#4FC4C4',
    accent: '#2FA3A3',
    accentForeground: '#0F141F',
    bgElev: '#1A1F2D',
    surfaceCard: '#1A1F2D',
    surfaceCardAlt: '#232A3A',
    borderStrong: '#3A4357',
    textInverse: '#1E2B4B',
    textStrong: '#CBD2DE',
    textQuiet: '#9AA3B5',
    ringFocus: '#4FC4C4',
};
export const cltAccentTokens = {
    skyline: '#0E7B7B',
    skylineLight: '#2FA3A3',
    skylineDeep: '#075959',
    skylineGlow: '#4FC4C4',
    skylineWash: 'rgba(14, 123, 123, 0.12)',
    ember: '#E8833A',
    emberLight: '#F2A267',
};
export const cltAccentForegroundTokensLight = {
    skylineGlowFg: '#0A6363',
    emberFg: '#8A4B12',
    emberDeep: '#9A4E0A',
};
export const cltAccentForegroundTokensDark = {
    skylineGlowFg: '#4FC4C4',
    emberFg: '#E8833A',
    emberDeep: '#9A4E0A',
};
export const sunkenBackgroundTokens = {
    light: '#EEF1F6',
    dark: '#070A12',
};
export const fontFamilyTokens = {
    display: "'Space Grotesk', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    body: "'Inter', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    mono: "'JetBrains Mono', ui-monospace, 'SFMono-Regular', 'Menlo', 'Consolas', 'Liberation Mono', monospace",
};
/** Bare→canonical aliases ThemeProvider also writes inline (`@runtime-alias`). */
export const runtimeAliases = {
    '--secondary': '--loci-color-secondary',
    '--bg': '--loci-color-background',
    '--fg-1': '--loci-color-text',
    '--border': '--loci-color-border',
    '--bg-elev': '--loci-color-bg-elev',
    '--surface': '--loci-color-surface-card',
    '--surface-alt': '--loci-color-surface-card-alt',
    '--border-strong': '--loci-color-border-strong',
    '--fg-inverse': '--loci-color-text-inverse',
    '--fg-2': '--loci-color-text-strong',
    '--fg-3': '--loci-color-text-quiet',
    '--ring': '--loci-color-ring-focus',
    '--r-none': '--loci-radius-none',
    '--r-xs': '--loci-radius-xs',
    '--r-sm': '--loci-radius-sm',
    '--r-md': '--loci-radius-md',
    '--r-pill': '--loci-radius-pill',
    '--r-lg': '--loci-radius-card-lg',
    '--r-xl': '--loci-radius-card-xl',
    '--r-2xl': '--loci-radius-card-2xl',
    '--shadow-xs': '--loci-shadow-xs',
    '--shadow-sm': '--loci-shadow-sm',
    '--shadow-md': '--loci-shadow-md',
    '--shadow-lg': '--loci-shadow-lg',
    '--shadow-xl': '--loci-shadow-xl',
    '--sp-0': '--loci-spacing-0',
    '--sp-1': '--loci-spacing-1',
    '--sp-2': '--loci-spacing-2',
    '--sp-3': '--loci-spacing-3',
    '--sp-4': '--loci-spacing-4',
    '--sp-5': '--loci-spacing-5',
    '--sp-6': '--loci-spacing-6',
    '--sp-7': '--loci-spacing-7',
    '--sp-8': '--loci-spacing-8',
    '--sp-10': '--loci-spacing-10',
    '--sp-12': '--loci-spacing-12',
    '--sp-16': '--loci-spacing-16',
    '--sp-20': '--loci-spacing-20',
    '--sp-24': '--loci-spacing-24',
    '--fs-micro': '--loci-font-size-micro',
    '--fs-caption': '--loci-font-size-caption',
    '--fs-small': '--loci-font-size-small',
    '--fs-body': '--loci-font-size-body',
    '--fs-lead': '--loci-font-size-lead',
    '--fs-h6': '--loci-font-size-h6',
    '--fs-h5': '--loci-font-size-h5',
    '--fs-h4': '--loci-font-size-h4',
    '--fs-h3': '--loci-font-size-h3',
    '--fs-h2': '--loci-font-size-h2',
    '--fs-h1': '--loci-font-size-h1',
    '--fs-display': '--loci-font-size-display',
    '--fs-mega': '--loci-font-size-mega',
    '--lh-tight': '--loci-line-height-tight',
    '--lh-snug': '--loci-line-height-snug',
    '--lh-normal': '--loci-line-height-normal',
    '--lh-loose': '--loci-line-height-loose',
};
